'use client'

import Tag from '@/components/Tag'
import { usePathname } from 'next/navigation'
import clsx from 'clsx'

interface TagFiltersProps {
	tags: any
	className?: string
}

export default function TagFilters({ className, tags }: TagFiltersProps) {
	const pathname = usePathname()

	return (
		<ul className={clsx('px-site-margin flex items-center flex-wrap gap-4 mt-[4rem] mb-[2rem] sm:mt-[4rem] sm:mb-[2rem] md:mt-[6rem] md:mb-[4rem]', className)}>
			<li>
				<Tag title={'All'} href={'/journal'} isActive={pathname === `/journal`} />
			</li>
			{tags.map((tag: any) => (
				<li key={tag.slug.current}>
					<Tag title={tag?.title} href={`/journal/tag/${tag.slug.current}`} isActive={pathname === `/journal/tag/${tag.slug.current}`} />
				</li>
			))}
		</ul>
	)
}
